import styled from '@emotion/styled';
import { Props } from 'components/NavLink/NavLink';

const PrefButtonWrapper = styled('span')<Partial<Props> & { log?: boolean }>({
  display: 'inline-block',
  verticalAlign: 'top',
});

export default PrefButtonWrapper;
